import styled from '@emotion/styled';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';
import { BreakPointToken } from '../../hooks/useMediaQuery';
import { StyledScrollbars } from '../../lib/utils/mixins';

export const DATEPICKER_STYLES = {
	GUTTER: 24,
	WIDTH: 280
};

export const Pickers = styled.div`
	height: 100%;

	@media (min-width: ${BreakPointToken.LgMin}px) {
		overflow-y: auto;
		height: auto;
	}
`;

export const DateCarousel = styled.section`
	display: flex;

	& > button {
		align-self: center;
	}
`;

export const Slider = styled.section`
	display: flex;
	overflow: auto;
	width: ${DATEPICKER_STYLES.WIDTH * 2 + DATEPICKER_STYLES.GUTTER}px;
	overflow-x: scroll;
	scroll-snap-type: x mandatory;
	margin: 0 ${DATEPICKER_STYLES.GUTTER}px;
	gap: ${DATEPICKER_STYLES.GUTTER}px;
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */

	& > div {
		scroll-snap-align: start;
	}
	/* Chrome, Safari and Opera */
	&::-webkit-scrollbar {
		display: none;
	}
`;

export const DaysHeading = styled.div`
	color: var(--token-color-colour-text-secondary);
	border-top: 1px solid var(--token-color-colour-border-minimal);
	border-bottom: 1px solid var(--token-color-colour-border-minimal);
	margin-bottom: ${tokens.spacing.size_16px.height}px;
	position: sticky;
	top: 0;
	background: white;

	> div {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		text-align: center;
		margin-top: ${tokens.spacing.size_16px.height}px;
		margin-bottom: ${tokens.spacing.size_16px.height}px;
		max-width: ${DATEPICKER_STYLES.WIDTH}px;

		@media (max-width: ${BreakPointToken.MdMax}px) {
			margin-right: auto;
			margin-left: auto;
		}
	}
`;

export const ScrollBarMobile = styled.div`
	${StyledScrollbars};

	position: relative;
	height: 100%;
`;
